import React, { useState } from "react";
import toast from "react-hot-toast";

const INFOS = [
  { icon: "📞", label: "Téléphone", value: "+225 05 75 49 64 57 / 07 77 88 00 82", href: "tel:+2250575496457" },
  { icon: "✉️", label: "Email", value: "contact@purepro-group.ci", href: "mailto:contact@purepro-group.ci" },
  { icon: "📍", label: "Adresse", value: "Abidjan, Côte d'Ivoire", href: null },
  { icon: "⏰", label: "Horaires", value: "Lun – Sam : 08h00 – 18h00", href: null },
  { icon: "🔴", label: "Urgences", value: "24h/24 – 7j/7", href: null },
];

const SUBJECTS = [
  "Renseignement général",
  "Service Nettoyage",
  "Service Piscine",
  "Service Climatisation",
  "Traitement Nuisibles 3D",
  "Application Mobile",
  "Site Web",
  "Cybersécurité",
  "Équipement IT",
  "Formation & IA",
  "Partenariat",
  "Autre",
];

export default function Contact() {
  const [form, setForm] = useState({ name: "", email: "", phone: "", subject: "", message: "" });
  const [sending, setSending] = useState(false);
  const [sent, setSent] = useState(false);

  const set = (k) => (e) => setForm(f => ({ ...f, [k]: e.target.value }));

  const submit = async (e) => {
    e.preventDefault();
    if (!form.name || !form.email || !form.message) {
      toast.error("Veuillez remplir tous les champs obligatoires.");
      return;
    }
    setSending(true);
    try {
      const res = await fetch("https://back-purepro.onrender.com/messages", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({
          name: form.name,
          email: form.email,
          phone: form.phone,
          subject: form.subject || "Message depuis PurePro Group",
          content: form.message,
          source: "pureprogroup",
        }),
      });
      if (!res.ok) throw new Error();
      setSent(true);
      toast.success("Message envoyé ! Nous vous répondrons sous 24h.");
    } catch {
      toast.error("Erreur lors de l'envoi. Réessayez ou appelez-nous directement.");
    } finally {
      setSending(false);
    }
  };

  if (sent) {
    return (
      <div style={{ paddingTop: "72px", minHeight: "80vh", display: "flex", alignItems: "center", justifyContent: "center" }}>
        <div style={{ textAlign: "center", maxWidth: "500px", padding: "0 24px" }}>
          <div style={{ fontSize: "64px", marginBottom: "20px" }}>✅</div>
          <h2 style={{ fontFamily: "'Playfair Display',serif", fontSize: "28px", color: "#0a2540", marginBottom: "12px" }}>
            Message envoyé !
          </h2>
          <p style={{ color: "#4a5a6a", fontSize: "16px", lineHeight: 1.7, marginBottom: "28px" }}>
            Merci <strong>{form.name}</strong>. Notre équipe vous répondra sous 24h ouvrables
            à l'adresse <strong>{form.email}</strong>.
          </p>
          <button className="btn btn-primary" onClick={() => { setSent(false); setForm({ name: "", email: "", phone: "", subject: "", message: "" }); }}>
            Envoyer un autre message
          </button>
        </div>
      </div>
    );
  }

  return (
    <div style={{ paddingTop: "72px" }}>
      {/* Styles responsives */}


      {/* ─── Hero ─── */}
      <section style={s.hero}>
        <div style={s.heroBg} />
        <div className="container" style={{ position: "relative", zIndex: 2 }}>
          <span className="section-tag">Parlons de votre projet</span>
          <h1 style={s.heroTitle}>Contactez-<span style={{ color: "#c9a227" }}>nous</span></h1>
          <p style={s.heroSub}>
            Notre équipe est disponible pour répondre à toutes vos questions. Nous vous recontactons sous 24h.
          </p>
        </div>
      </section>

      {/* ─── Contenu ─── */}
      <section className="section">
        <div className="container">
          <div className="contact-grid">

            {/* ─ Infos ─ */}
            <div>
              <div style={s.infoTitle}>Nos coordonnées</div>
              <div className="gold-line" />
              <p style={s.infoSub}>
                Vous pouvez nous joindre par téléphone, email ou en remplissant le formulaire ci-contre.
                Pour les urgences, nous sommes disponibles 24h/24.
              </p>
              <div style={{ display: "flex", flexDirection: "column", gap: "14px", marginTop: "28px" }}>
                {INFOS.map(({ icon, label, value, href }) => (
                  <div key={label} style={s.infoRow}>
                    <div style={s.infoIcon}>{icon}</div>
                    <div>
                      <div style={s.infoLabel}>{label}</div>
                      {href
                        ? <a href={href} style={{ fontSize: "14px", color: "#0a2540", fontWeight: 600, textDecoration: "none" }}>{value}</a>
                        : <div style={{ fontSize: "14px", color: "#0a2540", fontWeight: 600 }}>{value}</div>
                      }
                    </div>
                  </div>
                ))}
              </div>

              {/* Entités */}
              <div style={{ marginTop: "36px" }}>
                <div style={s.infoTitle}>Nos entités</div>
                <div className="gold-line" />
                <a href="https://www.pureprocleaners.ci" target="_blank" rel="noreferrer" style={s.entityLink}>
                  <div style={{ ...s.entityDot, background: "#2d9b5c" }} />
                  <div>
                    <div style={{ fontWeight: 700, fontSize: "14px", color: "#0a2540" }}>Purepro Cleaners</div>
                    <div style={{ fontSize: "12px", color: "#8a9aaa" }}>Nettoyage, Piscines, Clim, 3D</div>
                  </div>
                </a>
                <a href="https://www.purepro-technologie.ci" target="_blank" rel="noreferrer" style={s.entityLink}>
                  <div style={{ ...s.entityDot, background: "#f97316" }} />
                  <div>
                    <div style={{ fontWeight: 700, fontSize: "14px", color: "#0a2540" }}>Purepro Technologie</div>
                    <div style={{ fontSize: "12px", color: "#8a9aaa" }}>Apps, Web, Sécurité, IT, IA</div>
                  </div>
                </a>
              </div>
            </div>

            {/* ─ Formulaire ─ */}
            <div style={s.formCard}>
              <h2 style={s.formTitle}>Envoyer un message</h2>
              <p style={s.formSub}>Remplissez le formulaire, nous vous répondons sous 24h.</p>
              <form onSubmit={submit} style={{ display: "flex", flexDirection: "column", gap: "16px" }}>
                <div className="form-row">
                  <div style={s.field}>
                    <label style={s.label}>Nom complet *</label>
                    <input style={s.input} placeholder="Jean Kouamé" value={form.name} onChange={set("name")} required />
                  </div>
                  <div style={s.field}>
                    <label style={s.label}>Email *</label>
                    <input style={s.input} type="email" placeholder="jean@exemple.com" value={form.email} onChange={set("email")} required />
                  </div>
                </div>
                <div className="form-row">
                  <div style={s.field}>
                    <label style={s.label}>Téléphone</label>
                    <input style={s.input} placeholder="+225 07 00 00 00 00" value={form.phone} onChange={set("phone")} />
                  </div>
                  <div style={s.field}>
                    <label style={s.label}>Sujet</label>
                    <select style={s.input} value={form.subject} onChange={set("subject")}>
                      <option value="">Sélectionner...</option>
                      {SUBJECTS.map(s2 => <option key={s2} value={s2}>{s2}</option>)}
                    </select>
                  </div>
                </div>
                <div style={s.field}>
                  <label style={s.label}>Message *</label>
                  <textarea style={{ ...s.input, minHeight: "140px", resize: "vertical" }} placeholder="Décrivez votre besoin ou votre question..." value={form.message} onChange={set("message")} required />
                </div>
                <button type="submit" className="btn btn-primary" disabled={sending} style={{ fontSize: "15px", padding: "14px 28px", justifyContent: "center", opacity: sending ? .7 : 1 }}>
                  {sending ? "Envoi en cours..." : "Envoyer le message →"}
                </button>
              </form>
            </div>
          </div>
        </div>
      </section>
            <style>{`
        /* Base */
        .container {
          max-width: 1280px;
          margin: 0 auto;
          padding: 0 24px;
        }
        .section {
          padding: 80px 0;
        }
        .section-tag {
          font-size: 12px;
          font-weight: 700;
          letter-spacing: 2px;
          text-transform: uppercase;
          color: #c9a227;
          display: inline-block;
        }
        .gold-line {
          width: 60px;
          height: 3px;
          background: #c9a227;
          margin: 16px 0 20px;
        }
        .btn-primary {
          background: #c9a227;
          color: #0a2540;
          border: none;
          border-radius: 40px;
          font-weight: 700;
          text-decoration: none;
          transition: all 0.2s;
          cursor: pointer;
          text-align: center;
          display: inline-block;
        }
        .btn-primary:hover {
          background: #b38c1a;
          transform: translateY(-2px);
        }
        /* Grille responsive */
        .contact-grid {
          display: grid;
          grid-template-columns: 1fr 1.4fr;
          gap: 60px;
          align-items: start;
        }
        /* Formulaire responsive */
        .form-row {
          display: grid;
          grid-template-columns: 1fr 1fr;
          gap: 16px;
        }
        /* Media queries */
        @media (max-width: 992px) {
          .section { padding: 60px 0; }
          .contact-grid { gap: 40px; }
        }
        @media (max-width: 768px) {
          .container { padding: 0 20px; }
          .contact-grid { grid-template-columns: 1fr; gap: 48px; }
          .form-row { grid-template-columns: 1fr; }
          .hero-title { font-size: 32px !important; }
          .hero-sub { font-size: 15px !important; }
          .form-card { padding: 28px !important; }
        }
        @media (max-width: 480px) {
          .section-title { font-size: 28px; }
          .form-card { padding: 20px !important; }
          .btn-primary { width: 100%; text-align: center; }
        }
      `}</style>
    </div>
  );
}

const s = {
  hero: { background: "linear-gradient(135deg, #0a2540 0%, #1e3a5f 100%)", padding: "70px 0", position: "relative", overflow: "hidden" },
  heroBg: { position: "absolute", inset: 0, background: "radial-gradient(ellipse at 80% 50%, rgba(201,162,39,.08), transparent 60%)" },
  heroTitle: { fontFamily: "'Playfair Display',serif", fontSize: "clamp(32px,5vw,50px)", fontWeight: 700, color: "#fff", lineHeight: 1.2, margin: "14px 0 18px" },
  heroSub: { fontSize: "16px", color: "rgba(255,255,255,.7)", maxWidth: "520px", lineHeight: 1.8 },
  infoTitle: { fontSize: "14px", fontWeight: 700, color: "#0a2540", letterSpacing: ".5px" },
  infoSub: { fontSize: "14px", color: "#4a5a6a", lineHeight: 1.8 },
  infoRow: { display: "flex", gap: "14px", alignItems: "flex-start" },
  infoIcon: { width: "40px", height: "40px", borderRadius: "10px", background: "rgba(201,162,39,.1)", border: "1px solid rgba(201,162,39,.2)", display: "flex", alignItems: "center", justifyContent: "center", fontSize: "16px", flexShrink: 0 },
  infoLabel: { fontSize: "11px", fontWeight: 700, letterSpacing: "1px", textTransform: "uppercase", color: "#8a9aaa", marginBottom: "2px" },
  entityLink: { display: "flex", alignItems: "center", gap: "12px", padding: "12px 16px", border: "1px solid #d8e0e8", borderRadius: "10px", marginBottom: "10px", textDecoration: "none", transition: "all .2s" },
  entityDot: { width: "10px", height: "10px", borderRadius: "50%", flexShrink: 0 },
  formCard: { background: "#fff", border: "1px solid #d8e0e8", borderRadius: "20px", padding: "36px", boxShadow: "0 8px 40px rgba(10,37,64,.1)" },
  formTitle: { fontFamily: "'Playfair Display',serif", fontSize: "22px", fontWeight: 700, color: "#0a2540", marginBottom: "6px" },
  formSub: { fontSize: "13px", color: "#8a9aaa", marginBottom: "24px" },
  field: { display: "flex", flexDirection: "column", gap: "6px" },
  label: { fontSize: "12px", fontWeight: 700, color: "#0a2540", letterSpacing: ".3px" },
  input: { padding: "11px 14px", border: "1.5px solid #d8e0e8", borderRadius: "8px", fontSize: "14px", color: "#1a2a3a", outline: "none", fontFamily: "inherit", width: "100%", background: "#fafbfc", transition: "border .2s" },
};